module.exports = __webpack_public_path__ + "img/horizontal_3_2_r_9006.56765ad4.png";